module.exports = __webpack_public_path__ + "img/features-split-top-02.486abb20.png";